export enum TypePractice {
  Unavailable = 'CIR',
  UntraceableCensus = 'CIC',
  Registerofficetemporary = 'PTR',
  Immigration = 'PIM',
  Emigration = 'PEE',
  EmigrationN010 = 'PEI',
  EmigrationC01 = 'C01',
  Residence = 'RES',
}
